'use strict';

require('../less/mricode.pagination.less');

$(function () {
    var pageUrl = getUrl();
    $('#go_page').click(function () {
        var pageNo = $('#pageNo').val();
        if (pageNo == '') {
            return;
        }
        window.location.href = pageUrl + pageNo;
    });
    function getUrl() {
        var url = $('#page_first').attr('href');
        var urlArr = url.split('-');
        urlArr.pop();
        url = urlArr.join('-');
        return url + '-';
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/js/page.js
// module id = 26
// module chunks = 0 8 10 12